const QuotedKeyCreator = ({ value }) => {
    if (!value || value === '') {
        return 'N';
    } else {
        return value;
    }
};

export default QuotedKeyCreator;
